import { api } from "./api";

const dealerApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDealers: builder.query({
      query: () => "dealers",
      providesTags: ["dealers"],
    }),
    addDealer: builder.mutation({
      query: (newCategory) => ({
        url: "dealers",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["dealers"],
    }),
    removeDealer: builder.mutation({
      query: (id) => ({
        url: `dealers/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["dealers"],
    }),
    editDealer: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/dealers/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["dealers"],
    }),
  }),
});

export const {
  useGetDealersQuery,
  useAddDealerMutation,
  useRemoveDealerMutation,
  useEditDealerMutation,
} = dealerApi;
